export class DetallesProductosGenerales {
    constructor(
        public CodigoUsuarioExtranet?: number,
        public CodigoProducto?: number,
        public CodigoCliente?: number,
        public CodigoCiudad?: number,
        public DetalleProducto?: string,
        public ValorAsegurado?: number,
        public CodigoProdGeneral?: number,
        public Poliza?: string,
        public InicioVigencia?: Date,
        public FinVigencia?: Date,
        public CodigoEjecutivoCuenta?: number,
        public Producto?: string,
        public Aseguradora?: string
    ){
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/masivos/datosGenerales/entities/detalle_otros_ramos_entity.ts